import token from "../../images/bigodToken.webp";
import { useGetLivePriceBingold } from "../../api/livePrice/livePriceApi";

const TokenPrice = () => {
  const { data, isLoading ,isError} = useGetLivePriceBingold();
  const price = data ? Number(data?.data[0]?.tokenPrice).toFixed(4) : "Loading...";
  

 
  return (
    <div className=" flex items-center gap-4 bg-gradient-to-r from-[#00A2F9] to-[#0066FF] text-white px-6 py-3 rounded-full shadow-2xl border border-white/20  ">
      <img
        src={token}
        alt="Token"
        className="h-[40px] w-[40px] drop-shadow-lg"
      />

      <div>
        <div className="flex items-center gap-2">
          <h4 className="text-lg font-semibold tracking-wide">Token Price</h4>
          <span className="flex items-center gap-1">
            <span className="relative w-3 h-3">
              <span className="absolute top-0 left-0 w-3 h-3 bg-green-400 rounded-full animate-ping"></span>
              <span className="absolute top-0 left-0 w-3 h-3 bg-green-400 rounded-full"></span>
            </span>
            <span className="text-green-400 font-bold text-xs">LIVE</span>
          </span>
        </div>
        {isLoading ? <p>Loading...</p> :  <p className="text-2xl font-extrabold">${price}</p>}
        {isError && <p className="text-2xl font-extrabold"></p>}
       
      </div>
    </div>
  );
};

export default TokenPrice;
